'use strict';

angular.module('atex.dam').factory('DamAclPermissionService',['ContentService','DamService','$q', 
function(ContentService, DamService, $q) {
  function DamAclPermissionService( ) {}

  var getSecurityParentId = function (aspects) {
    var securityParent = atex.onecms.ObjectUtils.getByPath(aspects, 'p.InsertionInfo/data/securityParentId');
    if (typeof securityParent === 'undefined') {
      securityParent = atex.onecms.ObjectUtils.getByPath(aspects, 'p.InsertionInfo/data/insertParentId') || "";
      console.log('Missing securityParentId' + (securityParent ? ', using insertParentId' : '') + ' check the data',
        _.extend({}, aspects));
    }
    return atex.dam.AngularUtils.removePrefix(securityParent);
  };

  DamAclPermissionService.check = function(contentIds,permission) {
    var checkedSecParent = [];
    var promises = contentIds.map(function (contentId) {
      return ContentService.getContent({id :contentId}).then(function(content) {
        var securityParent = getSecurityParentId(content.data.aspects);
        var found = _.find(checkedSecParent, function (secParentEntry) {
          return secParentEntry === securityParent;
        });
        if (found) {
          return;
        }
        var json = atex.dam.AngularUtils.buildPermissionRequest(securityParent,permission);  
        return  DamService.permission(json).then(function(permission) {
          return permission.data;	
        });	   
   	  });
    });	

    return $q.all(promises);
  };

  DamAclPermissionService.checkEx = function(entries,permission) {
    var checkedSecParent = [];
    var promises = entries.map(function (entry) {
      var securityParent = getSecurityParentId(entry._data.aspects);
      var found = _.find(checkedSecParent, function (secParentEntry) {
        return secParentEntry === securityParent;
      });
      if (found) {
        return;
      }
      checkedSecParent.push(securityParent);
      var json = atex.dam.AngularUtils.buildPermissionRequest(securityParent,permission);
      return DamService.permission(json).then(function(permission) {
        return permission.data;
      });
    });

    return $q.all(promises);
  };

  DamAclPermissionService._hasPermission = function (contentIds, permission) {
    return $q(function (resolve, reject) {
      DamAclPermissionService.check(contentIds, permission).then(function (results) {
        results = results.filter(function (result) {
          return (result === "false");
        });
        resolve(results.length === 0);
      }).then(null, function (error) {
        reject(error);
      });
    });
  };

  DamAclPermissionService._hasPermissionEx = function(entries,permission) {
    return $q(function(resolve, reject) {
      DamAclPermissionService.checkEx(entries,permission).then(function (results) {
        results = results.filter(function (result) {
          return (result === "false");
        });
        resolve(results.length === 0);
      }).then(null, function(error) {
        reject(error);
      });
    });
  };

  DamAclPermissionService._getSite = function (siteExternalId) {
    var externalId = siteExternalId || 'dam.d';
    return $q(function (resolve, reject) {
      window.atex = window.atex || {};
      window.atex.externalIdsCache = window.atex.externalIdsCache || {};
      if (window.atex.externalIdsCache[externalId]) {
        resolve(window.atex.externalIdsCache[externalId]);
      } else {
        ContentService.getContent({id: 'externalid/' + externalId}).then(function (responseInfo) {
          var contentId = atex.dam.AngularUtils.removePrefix(responseInfo.id);
          window.atex.externalIdsCache[externalId] = contentId;
          resolve(contentId);
        }).then(null, function(error) {
          reject(error);
        });
      }
    });
  };

  DamAclPermissionService._checkPermission = function (contentId, permission, decorate) {
    var json = atex.dam.AngularUtils.buildPermissionRequest(contentId, permission, decorate);
    return DamService.permission(json).then(function(permission) {
      return (permission.data === "true");
    });
  };
  
  DamAclPermissionService.hasWritePermission = function(contentIds) { 
    return DamAclPermissionService._hasPermission(contentIds,"WRITE");
  };

  DamAclPermissionService.hasWritePermissionEx = function(entries) {
    return DamAclPermissionService._hasPermissionEx(entries,"WRITE");
  };
  
  DamAclPermissionService.hasDeletePermission = function(contentIds) {
    return DamAclPermissionService._hasPermission(contentIds,"REMOVE");  
  };

  DamAclPermissionService.hasDeletePermissionEx = function(entries) {
    return DamAclPermissionService._hasPermissionEx(entries,"REMOVE");
  };
  
  DamAclPermissionService.hasCreatePermission = function(contentIds) {
    return DamAclPermissionService._hasPermission(contentIds,"CREATE");  
  };

  DamAclPermissionService.hasQueryEmailAlertPermission = function(siteExternalId) {
    return DamAclPermissionService._getSite(siteExternalId).then(function(contentId) {
      return DamAclPermissionService._checkPermission(contentId, 'QUERYEMAILALERT', false);
    });
  };
  
  DamAclPermissionService.prototype = {
    constructor: DamAclPermissionService
  };
  
  return(DamAclPermissionService);
}]);  
